module.exports = __webpack_public_path__ + "static/5-4b7ae133370eb94afd28e8c7186b05f0.jpg";